/*
 * @Author: your name
 * @Date: 2021-05-18 09:42:33
 * @LastEditTime: 2021-05-18 09:42:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ipublishment-ssr-web/components/ipub-ui/packages/icon/index.js
 */
import IpubFormItem from '../form/src/item'

/* istanbul ignore next */
IpubFormItem.install = function(Vue) {
  Vue.component(IpubFormItem.name, IpubFormItem)
}

export default IpubFormItem
